/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DetencaoFontesSeladasAutorizacaoFormDto } from '../models/detencao-fontes-seladas-autorizacao-form-dto';
import { DetencaoFontesSeladasCriteriaDto } from '../models/detencao-fontes-seladas-criteria-dto';
import { DetencaoFontesSeladasDto } from '../models/detencao-fontes-seladas-dto';
import { DetencaoFontesSeladasImportacaoFormDto } from '../models/detencao-fontes-seladas-importacao-form-dto';
import { DetencaoFontesSeladasPageDto } from '../models/detencao-fontes-seladas-page-dto';
import { DetencaoFontesSeladasRenovacaoFormDto } from '../models/detencao-fontes-seladas-renovacao-form-dto';
import { DetencaoFontesSeladasSemRegistoFormDto } from '../models/detencao-fontes-seladas-sem-registo-form-dto';
import { DetencaoFontesSeladasSummaryDto } from '../models/detencao-fontes-seladas-summary-dto';
import { DetencaoFontesSeladasTransmissaoFormDto } from '../models/detencao-fontes-seladas-transmissao-form-dto';


/**
 * Detenção de Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class DetencaoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDetencoesFontesSeladas
   */
  static readonly GetDetencoesFontesSeladasPath = '/detencao-fontes-seladas';

  /**
   * Pesquisar Detenções de Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDetencoesFontesSeladas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetencoesFontesSeladas$Response(params?: {
    criteria?: DetencaoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.GetDetencoesFontesSeladasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Detenções de Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDetencoesFontesSeladas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetencoesFontesSeladas(params?: {
    criteria?: DetencaoFontesSeladasCriteriaDto;
  }): Observable<DetencaoFontesSeladasPageDto> {

    return this.getDetencoesFontesSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasPageDto>) => r.body as DetencaoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation submeterDetencaoFsSemRegisto
   */
  static readonly SubmeterDetencaoFsSemRegistoPath = '/detencao-fontes-seladas';

  /**
   * Submeter Pedido de Enquadramento Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterDetencaoFsSemRegisto()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterDetencaoFsSemRegisto$Response(params?: {
    body?: {
'detencaoFSForm'?: DetencaoFontesSeladasSemRegistoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'pecasDesenhadas'?: Blob;
'certFonte'?: Blob;
'certContentor'?: Blob;
'comprovativoValor'?: Blob;
'contratoDevolucao'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.SubmeterDetencaoFsSemRegistoPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Submeter Pedido de Enquadramento Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterDetencaoFsSemRegisto$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterDetencaoFsSemRegisto(params?: {
    body?: {
'detencaoFSForm'?: DetencaoFontesSeladasSemRegistoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'pecasDesenhadas'?: Blob;
'certFonte'?: Blob;
'certContentor'?: Blob;
'comprovativoValor'?: Blob;
'contratoDevolucao'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.submeterDetencaoFsSemRegisto$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation getDetencaoFontesSeladas
   */
  static readonly GetDetencaoFontesSeladasPath = '/detencao-fontes-seladas/{id}';

  /**
   * Obter pedido de detenção.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDetencaoFontesSeladas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetencaoFontesSeladas$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.GetDetencaoFontesSeladasPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Obter pedido de detenção.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDetencaoFontesSeladas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetencaoFontesSeladas(params: {
    id: number;
  }): Observable<DetencaoFontesSeladasDto> {

    return this.getDetencaoFontesSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasDto>) => r.body as DetencaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateDetencaoFsSemRegisto
   */
  static readonly UpdateDetencaoFsSemRegistoPath = '/detencao-fontes-seladas/{id}';

  /**
   * Editar Pedido de Enquadramento sem registo da Detenção Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDetencaoFsSemRegisto()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateDetencaoFsSemRegisto$Response(params: {
    id: number;
    body?: {
'detencaoFSForm'?: DetencaoFontesSeladasSemRegistoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'pecasDesenhadas'?: Blob;
'certFonte'?: Blob;
'certContentor'?: Blob;
'comprovativoValor'?: Blob;
'contratoDevolucao'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.UpdateDetencaoFsSemRegistoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar Pedido de Enquadramento sem registo da Detenção Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateDetencaoFsSemRegisto$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateDetencaoFsSemRegisto(params: {
    id: number;
    body?: {
'detencaoFSForm'?: DetencaoFontesSeladasSemRegistoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'pecasDesenhadas'?: Blob;
'certFonte'?: Blob;
'certContentor'?: Blob;
'comprovativoValor'?: Blob;
'contratoDevolucao'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.updateDetencaoFsSemRegisto$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoDetencaoFs
   */
  static readonly UpdateAutorizacaoDetencaoFsPath = '/detencao-fontes-seladas/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido de detenção de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoDetencaoFs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoDetencaoFs$Response(params: {
    id: number;
    body?: DetencaoFontesSeladasAutorizacaoFormDto
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.UpdateAutorizacaoDetencaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido de detenção de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoDetencaoFs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoDetencaoFs(params: {
    id: number;
    body?: DetencaoFontesSeladasAutorizacaoFormDto
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.updateAutorizacaoDetencaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateDetencaoFsImportacao
   */
  static readonly UpdateDetencaoFsImportacaoPath = '/detencao-fontes-seladas/{id}/importacao';

  /**
   * Editar pedido de detenção de fontes seladas - Aviso Receção Importação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDetencaoFsImportacao()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateDetencaoFsImportacao$Response(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasImportacaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
'pecasDesenhadas'?: Blob;
'certFonte'?: Blob;
'comprovativoValor'?: Blob;
'contratoDevolucao'?: Blob;
}
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.UpdateDetencaoFsImportacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar pedido de detenção de fontes seladas - Aviso Receção Importação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateDetencaoFsImportacao$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateDetencaoFsImportacao(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasImportacaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
'pecasDesenhadas'?: Blob;
'certFonte'?: Blob;
'comprovativoValor'?: Blob;
'contratoDevolucao'?: Blob;
}
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.updateDetencaoFsImportacao$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation submeterRenovacaoDetencaoFs
   */
  static readonly SubmeterRenovacaoDetencaoFsPath = '/detencao-fontes-seladas/{id}/renovacao';

  /**
   * Criar pedido de detenção de fontes seladas - renovação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterRenovacaoDetencaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterRenovacaoDetencaoFs$Response(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasRenovacaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.SubmeterRenovacaoDetencaoFsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Criar pedido de detenção de fontes seladas - renovação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterRenovacaoDetencaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterRenovacaoDetencaoFs(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasRenovacaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.submeterRenovacaoDetencaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateRenovacaoDetencaoFs
   */
  static readonly UpdateRenovacaoDetencaoFsPath = '/detencao-fontes-seladas/{id}/renovacao';

  /**
   * Editar pedido de detenção de fontes seladas - renovação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRenovacaoDetencaoFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateRenovacaoDetencaoFs$Response(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasRenovacaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.UpdateRenovacaoDetencaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar pedido de detenção de fontes seladas - renovação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateRenovacaoDetencaoFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateRenovacaoDetencaoFs(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasRenovacaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.updateRenovacaoDetencaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateDetencaoFsTransmissao
   */
  static readonly UpdateDetencaoFsTransmissaoPath = '/detencao-fontes-seladas/{id}/transmissao';

  /**
   * Editar pedido de detenção de fontes seladas - aviso de receção de uma transmissão.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDetencaoFsTransmissao()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateDetencaoFsTransmissao$Response(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasTransmissaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<DetencaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.UpdateDetencaoFsTransmissaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetencaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar pedido de detenção de fontes seladas - aviso de receção de uma transmissão.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateDetencaoFsTransmissao$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateDetencaoFsTransmissao(params: {
    id: number;
    body?: {
'formDto'?: DetencaoFontesSeladasTransmissaoFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<DetencaoFontesSeladasSummaryDto> {

    return this.updateDetencaoFsTransmissao$Response(params).pipe(
      map((r: StrictHttpResponse<DetencaoFontesSeladasSummaryDto>) => r.body as DetencaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoDetencao
   */
  static readonly PreviewDocAutorizacaoDetencaoPath = '/detencao-fontes-seladas/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoDetencao()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoDetencao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DetencaoFontesSeladasService.PreviewDocAutorizacaoDetencaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoDetencao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoDetencao(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoDetencao$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
